// extracted by mini-css-extract-plugin
export var root = "styles-module--root--3HzJk";
export var grid = "styles-module--grid--3mWSv";
export var item = "styles-module--item--2AbGj";
export var imageWrapper = "styles-module--image-wrapper--1KUHG";
export var doubleHeight = "styles-module--double-height--25upx";